<template>
    <div class="side-box">
        <a-layout-sider
            width="260"
            breakpoint="lg"
            collapsed-width="86"
            collapsible
            :trigger="null"
            v-model:collapsed="state.collapsed"
        >
            <div class="side-top">
                <img src="@/assets/icons/menus/logo.png" />
                <span class="side-text" v-if="!state.collapsed">经销商录入系统</span>
            </div>
            <div class="side-menu">
                <a-menu
                    mode="inline"
                    v-model:selectedKeys="state.selectedKeys"
                    :open-keys="state.openKeys"
                    @select="clickMenu"
                >
                    <template v-for="item in menuItems" :key="item">
                        <a-menu-item v-if="!item.sub_menus" :key="item.router">
                            <template #icon>
                                <img :class="state.selectedKeys == item.icon?'selected-icon':''" :src="require('@/assets/icons/menus/' + item.icon + '.png')">
                            </template>
                            <span>{{ item.name }}</span>
                        </a-menu-item>
                        <a-sub-menu v-else-if="item.sub_menus" :key="item.router">
                            <template #icon>
                                <img :src="require('@/assets/icons/menus/' + item.icon + '.png')"/>
                            </template>
                            <template #title>
                                <span>{{ item.name }}</span>
                            </template>
                            <a-menu-item
                                v-for="child in item.sub_menus"
                                :key="child.router"
                            >
                                <span>{{ child.name }}</span>
                            </a-menu-item>
                        </a-sub-menu>
                    </template>
                </a-menu>
            </div>
            <div class="collapsed-btn">
                <a-button @click="toggleCollapsed()" type="link">
                    <MenuUnfoldOutlined class="collapsed-icon" v-if="state.collapsed" />
                    <MenuFoldOutlined class="collapsed-icon" v-else />
                </a-button>
            </div>
        </a-layout-sider>
    </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import select from "@/utils/select.js";
import eventBus from "@/store/eventBus.js";

// 路由配置
const route = useRoute();
const router = useRouter();
const type = localStorage.getItem("type");
const isAdmin = localStorage.getItem("isAdmin");
//菜单配置
const state = reactive({
    collapsed: false, //是否折叠
    openKeys: [], //打开的父菜单 当前展开的 SubMenu 菜单项 key 数组
    selectedKeys: [], //当前选中的菜单项 key 数组
});
const menuItems = ref([]); //菜单列

const setMenu = () => { 
    // 菜单列表赋值
    if (type == '1' && isAdmin == "true") {
        menuItems.value = select.adminList;
    } else if (type == '1' && isAdmin == "false") {
        menuItems.value = select.techList;
    } else if (type == '2' || type == '3') {
        menuItems.value = select.userList;
    }
};

// 点击菜单跳转
const clickMenu = ({ key }) => {
    router.replace({ name: key }); //菜单栏路由跳转
};
// 是否折叠
const toggleCollapsed = () => {
    state.collapsed = !state.collapsed;
    nextTick(() => {
        eventBus.emit("sidebar-toggle", state.collapsed); // 发出事件
    });
};
// 去除路径中的前导斜杠
const normalizePath = (path) => {
    return path.startsWith("/") ? path.substring(1) : path;
};
// 根据路径找到对应的openKeys
const setOpenKeys = (path) => {
    const normalizedPath = normalizePath(path);
    let highlightKey = null; // 用于存储需要高亮显示的key

    for (let item of menuItems.value) {
        if (item.sub_menus) {
            for (let sub of item.sub_menus) {
                const subNormalizedPath = normalizePath(sub.router);
                if (subNormalizedPath === normalizedPath) {
                    state.openKeys = [item.router];
                    highlightKey = sub.router;
                    break;
                }
            }
            if (highlightKey) break;
        }
    }
    // 检查特殊路径并设置highlightKey和openKeys
    if (!highlightKey) {
        if (normalizedPath.includes("businessDetail")) {
            highlightKey = "business";
            state.openKeys = ["business"];
        } else if (normalizedPath.includes("userBusinessDetail")) {
            highlightKey = "userBusiness";
            state.openKeys = ["userBusiness"];
        }
    }
    // 设置选中的key
    if (highlightKey) {
        state.selectedKeys = [highlightKey];
    }
};

onMounted(() => { 
    setMenu();
});

onBeforeUnmount(() => { });

// 监听整个 route 对象的变化
watch(
    () => route,
    (newRoute) => {
        state.selectedKeys = [normalizePath(newRoute.path)];
        setOpenKeys(newRoute.path);
    },
    { deep: true, immediate: true }
);
</script>

<style lang="scss" scoped>
.side-box {
    z-index: 3;
}
.ant-layout .ant-layout-sider {
    height: 100%;
    background: transparent;
}
/* 顶部标题 */
.side-top {
    height: 66px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    gap: 8px;
    .side-text {
        font-family: "AlimamaShuHeiTi-Bold";
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 0em;
        color: #303133;
    }
}
/* 导航栏 */
.side-menu {
    padding: 0px 20px 20px;
    .selected-icon{
        filter: brightness(0) invert(1);
    }
}
/* 折叠 */
.collapsed-btn {
    position: absolute;
    bottom: 5px;
    right: 0px;
    .collapsed-icon {
        color: #C0C4CC;
    }
}
</style>